import {Mapper} from '@s-ui/domain'

export class FromParamsToTrackingPhoneRequestParamsValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.trackingPhoneRequestParamsValueObjectFactory
   */
  constructor({config, trackingPhoneRequestParamsValueObjectFactory}) {
    super()
    this._config = config
    this._trackingPhoneRequestParamsValueObjectFactory = trackingPhoneRequestParamsValueObjectFactory
  }

  map({sessionId, pageType, adobeAccount, params} = {}) {
    const filteredProvinces = params.multiprovince || this._config.get('filteredProvincesResults').UNKNOWN

    return this._trackingPhoneRequestParamsValueObjectFactory({
      sessionId,
      pageType,
      adobeAccount,
      ...params,
      filteredProvinces
    })
  }
}
